/**
 * partnerBulkActions.js — массовые операции над карточками партнёров.
 *
 * Вынесено из partnerCrm.js: тот файл упёрся в baseline размера компонента
 * (гейт check_component_size), а массовые действия — самостоятельная область
 * со своей защитой от повторной отправки.
 *
 * `idempotencyKey` формируется ОДИН раз при открытии модалки и живёт до её
 * закрытия. Повторная отправка (второй клик, ретрай после обрыва связи) не
 * должна давать по второму делу на каждую из ста карточек — тот же класс
 * отказа, что и двойное создание, только умноженный на размер выборки.
 */
import { apiFetch } from './core'

const BASE = '/partner-crm'

const withIdempotency = (key) => (key ? { headers: { 'Idempotency-Key': key } } : {})

export const partnerBulkActions = {
    planTouch: ({ partnerIds, touchType, dueDate, description, assigneeId, idempotencyKey }) =>
        apiFetch(`${BASE}/partners/bulk/plan-touch`, {
            method: 'POST',
            ...withIdempotency(idempotencyKey),
            body: JSON.stringify({
                partner_ids: partnerIds,
                touch_type: touchType,
                due_date: dueDate,
                description: description || null,
                assignee_id: assigneeId || null,
            }),
        }),

    assignManager: ({ partnerIds, managerId, idempotencyKey }) =>
        apiFetch(`${BASE}/partners/bulk/assign-manager`, {
            method: 'POST',
            ...withIdempotency(idempotencyKey),
            body: JSON.stringify({ partner_ids: partnerIds, manager_id: managerId }),
        }),
}
